import { useEffect } from 'react';
import Vex from 'vexflow';

import Styles from './MusicNote.module.css';

const { Factory } = Vex.Flow;

const MusicNote = ({ note, selectedInstrument, incorrect = false }) => {
  function convertNote(note) {
    const noteShiftMap = {
      C: 'A',
      D: 'B',
      E: 'C',
      F: 'D',
      G: 'E',
      A: 'F',
      B: 'G',
    };

    const match = note.match(/^([A-G])([b#]?)(\d)$/);
    let [_, baseNote, accidental, octave] = match;

    const shiftedNote = noteShiftMap[baseNote];
    let newOctave = parseInt(octave, 10);
    newOctave++; // Account for Vexflow issues
    if (baseNote !== 'C' && baseNote !== 'D') newOctave++;

    return `${shiftedNote}${accidental}${newOctave}`;
  }

  const highBrass = ['trumpet', 'frenchHorn'];
  let clef = 'treble';

  if (!highBrass.includes(selectedInstrument)) {
    clef = 'bass';
    note = convertNote(note);
  }
  useEffect(() => {
    const musicNote = document.getElementById('music-note');
    musicNote.innerHTML = '';

    const vf = new Factory({
      renderer: { elementId: 'music-note', width: 100, height: 150 },
    });
    const score = vf.EasyScore();

    const system = vf.System({
      x: -10,
      width: 400,
    });

    system
      .addStave({
        voices: [score.voice(score.notes(`${note}/w`, { stem: 'up' }))],
      })
      .addClef(clef);

    vf.draw();
  }, [note]);
  return (
    <div className={incorrect ? Styles.wrong : ''}>
      <div id="music-note" className={Styles.musicNote}></div>
    </div>
  );
};

export default MusicNote;